export default __webpack_public_path__ + "static/media/beko.e0f54fd4.svg";